import dynamic from 'next/dynamic';
import React, { useState } from 'react'

import { FAQ as F } from '../../interfaces'

const Chevron = dynamic(() => import('../../assets/chevron-up.svg'))
const Markdown = dynamic(() => import('./markdown'));

export default function FAQ(faq: F) {
  const [open, setOpen] = useState(false)
  return (
    <div>
      <button
        onClick={() => setOpen(!open)}
        type='button'
        className="faq focus:outline-none flex py-4 text-lg w-full justify-center items-center text-gray-900"
      >
        <span className="faq flex-1 text-left font-serif">{faq.heading}</span>
        <Chevron
          // @ts-ignore
          className={`text-gray-900 fill-current self-center transform transition-all duration-200 ${
            open ? '' : 'rotate-180'
          }`}
          width={16}
          height={16}
        />
      </button>
      <div
        className="border-t border-gold-500 overflow-hidden transition-all duration-200"
        style={{
          maxHeight: open ? '1000px' : 0,
        }}
      >
        <Markdown className="mt-8 prose prose-brand text-gray-600" source={faq.body} />
      </div>
    </div>
  )
}
